import StudyTypeEnum from "../../enums/StudyTypeEnum";

// Hasta sınıfları (HL7 PV1-2) ve çekim tipi karşılıkları; sözleşme bunları StudyTypeEnum değeriyle tutar.
export const PATIENT_CLASSES = [
    { code: 'O', value: StudyTypeEnum.ROUTINE, label: 'Outpatient' },
    { code: 'E', value: StudyTypeEnum.EMERGENCY, label: 'Emergency' },
    { code: 'I', value: StudyTypeEnum.INPATIENT, label: 'Inpatient' },
];

export const CONTRACT_STATUS = {
    NORMAL: 'normal',
    WARNING: 'warning',
    EXCEEDED: 'exceeded',
};

export const contractStatus = (contract) => {
    if (contract.usagePercent >= 100)
        return CONTRACT_STATUS.EXCEEDED;
    if (contract.usagePercent >= contract.warningPercent)
        return CONTRACT_STATUS.WARNING;
    return CONTRACT_STATUS.NORMAL;
}

export const CONTRACT_STATUS_COLOR = {
    [CONTRACT_STATUS.NORMAL]: '#52c41a',
    [CONTRACT_STATUS.WARNING]: '#faad14',
    [CONTRACT_STATUS.EXCEEDED]: '#ff4d4f',
};

// Artırım sunucudakiyle aynı formül: limit × (100 + %) / 100, aşağı yuvarlanır.
export const increasedLimit = (limit, percent) => Math.floor((limit || 0) * (100 + (percent || 0)) / 100);

export const formatNumber = (value) => (value ?? 0).toLocaleString();
